import { datadogRum as datadog } from '@datadog/browser-rum'
import config from '../../config'

const _extractError = response => {
  if (!response || !response.data) return null
  if (response.data.detail) return response.data.detail
  if (response.data.message) return response.data.message
  if (response.data.errors && response.data.errors[0].errorType) return response.data.errors[0].errorType

  return null
}

const _mountMsgError = (response = {}, msg = null) => {
  const errorText = (response.status && [400, 401].includes(response.status)) ? msg : 'somethingWrong'
  return (response.status === 401) ? errorText : `Errors.${errorText}`
}

const _cleanSensitiveData = (data = {}) => {
  if (!data || Object.keys(data).length === 0) return {}

  const privateFields = ['password', 'newPassword']
  try {
    const parsedData = JSON.parse(data)

    if (parsedData && Object.keys(parsedData).length) {
      privateFields.forEach(field => {
        if (field in parsedData) parsedData[field] = '***'
      })
    }

    return parsedData
  } catch (error) {
    return { error: error.message }
  }
}
export const errorService = (response = '') => {
  let msg = null
  let errorText = null

  const level =
    (response &&
      response.status &&
      [200, 201, 204].includes(response.status)) ||
    false

  if (!level) {
    msg = _extractError(response)
    errorText = _mountMsgError(response, msg)

    const errorBody = {
      status: response.status,
      level,
      msg,
      headers: response.headers,
      data: response.data,
      requestBody:
        response && response.config && response.config.data
          ? _cleanSensitiveData(response.config.data)
          : {}
    }

    if (process.env.NODE_ENV !== 'development' && config.datadog.enable) datadog.addError(errorBody)
  }

  const { status = null, data = null, headers = null } = response

  return {
    status,
    level,
    headers,
    data,
    errorText
  }
}



// WEBPACK FOOTER //
// ./src/services/errorService.js